/**
 * apiConfig.js — Single source of truth for the backend API base URL.
 *
 * Development  : set REACT_APP_API_URL in .env.local → http://localhost:8000
 * Production   : set REACT_APP_API_URL to your server URL (e.g. https://yourdomain.com)
 *                If left empty the app falls back to a relative path so it works
 *                when the React build is served by the FastAPI backend on the same host.
 */
const API_BASE =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:8000"
    : `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ""
      }`);

export default API_BASE;
